import React, { useState, useEffect } from 'react';
import './MyWork.css';

const MyWork = ({ token, user }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMyWork();
  }, []);

  const fetchMyWork = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/my-work`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setItems(data.items || []);
      }
    } catch (error) {
      console.error('Failed to fetch my work:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading-spinner"></div>;

  const groupedByStatus = items.reduce((acc, item) => {
    const status = item.status || 'Not Started';
    if (!acc[status]) acc[status] = [];
    acc[status].push(item);
    return acc;
  }, {});

  return (
    <div className="my-work-page">
      <h1 className="my-work-title">My Work</h1>
      <div className="my-work-columns">
        {Object.entries(groupedByStatus).map(([status, tasks]) => (
          <div key={status} className="my-work-column">
            <div className="column-header">
              <h3 className="column-title">{status}</h3>
              <span className="column-count">{tasks.length}</span>
            </div>
            <div className="column-content">
              {tasks.map((task) => (
                <div key={task.id} className="task-card" data-testid="my-work-task-card">
                  <div className="task-card-name">{task.name}</div>
                  <div className="task-card-meta">
                    <span className="task-card-board">{task.boardName}</span>
                    {task.dueDate && (
                      <span className="task-card-due">Due: {new Date(task.dueDate).toLocaleDateString()}</span>
                    )}
                  </div>
                  <span className={`priority-pill priority-${task.priority?.toLowerCase()}`}>
                    {task.priority}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyWork;